import { createSelector } from '@ngrx/store';
import { AppState } from './index';
import * as fromWordpress from './wordpress/wordpress.reducer';
import * as fromFixtures from './fixtures/fixtures.reducer';
import * as fromTeams from './teams/teams.reducer';
import { storeFixedPagesKey } from '@streamamg/components-lib';


export const State = (state: AppState) => state;

export const selectApplicationReady = createSelector(
  State,
  (state: AppState) => {

    return (
      state[fromWordpress.featureKey]?.status?.ready &&
      state[storeFixedPagesKey]?.status?.ready &&
      state[fromFixtures.featureKey]?.status?.ready &&
      state[fromTeams.featureKey]?.status?.ready
    );
  },
);
